import {Component, OnInit} from '@angular/core';
import {AlertService} from "../../services";
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import {MatDialog} from "@angular/material/dialog";
import {ComponentTitleService} from "../../services/componentTitle.service";
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";

import { locale as polish } from './i18n/pl';
import {PageLanguage} from "./model/pageLanguage";
import {PageService} from "./service/page.service";
import {Language} from "../language/model/language";

@Component({
    templateUrl: './pageForm.component.html',
    styleUrls: ['./pageForm.component.scss']
})

export class PageFormComponent implements OnInit {

    form: FormGroup;
    loading = false;
    submitted = false;
    id: string;
    isAddMode: boolean;
    categories: any[];
    units: any[];
    languages: PageLanguage[];

    constructor(
        public _matDialog: MatDialog,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private alertService: AlertService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        private pageService: PageService
    ) {
        this.translationLoader.loadTranslations(polish);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Pages');
    }

    ngOnInit() {
        this.id = this.route.snapshot.params['id'];
        this.isAddMode = !this.id;

        if (this.isAddMode) {
            this.componentTitleService.addPart('New');
        } else {
            this.componentTitleService.addPart('Edit');
        }

        this.form = this.formBuilder.group({
            tagName: ['', Validators.required],
            languages: this.formBuilder.array([]),
        });

        for (let i=0 ; i<this.route.snapshot.data.languages.items.length; i++) {
            this.addPageLanguage(this.route.snapshot.data.languages.items[i]);
        }

        if (!this.isAddMode) {
            // this.f.name.setValue(this.route.snapshot.data.page.name);

            for (let i=0 ; i<this.route.snapshot.data.languages.items.length; i++) {
                for (let j=0; j<this.route.snapshot.data.page.languages.length; j++) {
                    if (this.route.snapshot.data.page.languages[j].language.id !== this.route.snapshot.data.languages.items[i].id) {
                        continue;
                    }

                    this.setPageItemValue(
                        i,
                        this.route.snapshot.data.page.languages[j].visible,
                        this.route.snapshot.data.page.languages[j].name,
                        this.route.snapshot.data.page.languages[j].slug,
                        this.route.snapshot.data.page.languages[j].keywords,
                        this.route.snapshot.data.page.languages[j].shortDescription,
                        this.route.snapshot.data.page.languages[j].description,
                        this.route.snapshot.data.page.languages[j].metaDescription
                    );
                }
            }
        }
    }

    setPageItemValue(itemIdx: number, visible: boolean, name: string, slug: string, keywords: string, shortDescription: string, description: string, metaDescription: string) {
        this.pageLanguages().at(itemIdx).get('visible').setValue(name);
        this.pageLanguages().at(itemIdx).get('name').setValue(name);
        this.pageLanguages().at(itemIdx).get('slug').setValue(slug);
        this.pageLanguages().at(itemIdx).get('keywords').setValue(slug);
        this.pageLanguages().at(itemIdx).get('shortDescription').setValue(shortDescription);
        this.pageLanguages().at(itemIdx).get('description').setValue(description);
        this.pageLanguages().at(itemIdx).get('metaDescription').setValue(metaDescription);
    }

    // convenience getter for easy access to form fields
    get f() { return this.form.controls; }

    onSubmit() {
        this.submitted = true;

        // reset alerts on submit
        this.alertService.clear();

        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }

        this.loading = true;

        if (this.isAddMode) {
            this.createPage();
        } else {
            this.updatePage();
        }
    }

    pageLanguages(): FormArray {
        return this.form.get('languages') as FormArray;
    }

    newPageLanguage(language: Language): FormGroup {
        return this.formBuilder.group({
            id: [''],
            visible: [''],
            language: [language],
            name: [''],
            slug: [''],
            shortDescription: [''],
            description: [''],
            keywords: [''],
            metaDescription: [''],
        });
    }

    addPageLanguage(language: Language) {
        this.pageLanguages().push(this.newPageLanguage(language));
    }

    removePageLanguage(menuItemIdx: number) {
        this.pageLanguages().removeAt(menuItemIdx);
    }

    private createPage() {
        console.log('here');
        this.pageService.create(this.form.value)
            .pipe(first())
            .subscribe(
                data => {
                    this.alertService.success('Page added successfully', { keepAfterRouteChange: true });
                    this.router.navigate(['/cms/pages']);
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                });
    }

    private updatePage() {
        this.pageService.update(this.id, this.form.value)
            .pipe(first())
            .subscribe(
                data => {
                    this.alertService.success('Update successful', { keepAfterRouteChange: true });
                    this.router.navigate(['/cms/pages']);
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                });
    }
}
